import { API } from "../../../utils/api";

// Get recipe stock items list
export const getRecipeStockItems = async (recipeId) => {
  const res = await API.get(`recipes/${recipeId}/stocks`);
  return res.data.data;
};

// Delete recipe stock item
export const deleteRecipeStockItem = async ({ recipeId, stockId }) => {
  const res = await API.delete(`recipes/${recipeId}/stocks/${stockId}`);
  return res.data;
};

// Create recipe stock item
export const createRecipeStockItem = async ({ recipeId, payload }) => {
  const res = await API.post(`recipes/${recipeId}/stocks`, payload);
  return res.data;
};

// Get recipe stock item details
export const getRecipeStockItemDetails = async ({ recipeId, stockId }) => {
  const res = await API.get(`recipes/${recipeId}/stocks/${stockId}`);
  return res.data.data;
};

// Update recipe stock item
export const updateRecipeStockItem = async ({ recipeId, stockId, payload }) => {
  const res = await API.put(`recipes/${recipeId}/stocks/${stockId}`, payload);
  return res.data;
};
